import { FakDokumentStavka } from "../fak-dokument-stavka";

export class FakDokumentStavkaIzvoz extends FakDokumentStavka
{
    constructor(){
        super();
    }
    
    CenaUValuti: number = null;
    RabatVredUValuti: number = 0;
    OsnovicaUValuti: number = null;
    RabatUValuti = null;
    VrednostPreRabataStavkeUValuti: number = null;
    RabatStavkeUValuti: number = 0;
    OsnovicaStavkeUValuti: number = null;
    PdvStavkeUValuti: number = null;
    VrednostStavkeUValuti: number = null;
    CenaSaPDVUValuti: number = 0;

    Deserialize(input: any){
        // this.ID = input.ID;
        super.Deserialize(input);
        this.CenaUValuti = input.CenaUValuti;
        this.RabatVredUValuti = input.RabatVredUValuti;
        this.OsnovicaUValuti = input.OsnovicaUValuti;
        this.VrednostPreRabataStavkeUValuti=input.VrednostPreRabataStavkeUValuti;
        this.RabatStavkeUValuti=input.RabatStavkeUValuti;
        this.OsnovicaStavkeUValuti=input.OsnovicaStavkeUValuti;
        this.PdvStavkeUValuti=input.PdvStavkeUValuti;
        this.VrednostStavkeUValuti=input.VrednostStavkeUValuti;
        this.RabatUValuti = { Type: this.RabatTip, PValue: this.RabatProc, VValue: this.RabatVredUValuti };
        this.CenaSaPDVUValuti = input.CenaSaPDVUValuti;
        return this;
    }

    Serialize(input: FakDokumentStavkaIzvoz){
        input.RabatTip = input.RabatTip ? input.RabatTip : this.RabatUValuti ? this.Rabat.RabatType : 0;
        input.RabatProc = input.RabatProc ? input.RabatProc : this.RabatUValuti ? this.Rabat.RabatProc : 0;
        input.RabatVredUValuti = input.RabatVredUValuti ? input.RabatVredUValuti : this.RabatUValuti ? this.Rabat.RabatVredPoJmUValuti : 0;
        return input;
    }
}